<template>
  <div class="flex flex-col justify-between p-3 md:px-0 md:pt-8 md:pb-0">
    <bdg-files-list
      :items="plans"
      @view="viewPlan"
      @delete="deletePlan"
      :hide-delete-button="userType === UserTypes.CREW_SUPERVISOR"
      md-uses-buttons
      striped
    />

    <bdg-file-uploader
      class="mt-3"
      @change="onFileChange"
      :loading="isStoringContractPlan"
      v-if="userType !== UserTypes.CREW_SUPERVISOR"
    />
  </div>
</template>

<script>
import BdgFilesList from "../../elements/files-list/BdgFilesList";
import BdgFileUploader from "../../elements/files-list/BdgFileUploader";
import { UserTypes } from "../../constants/user-enums";

export default {
  name: "ContractPlans",
  components: { BdgFileUploader, BdgFilesList },
  data() {
    return {
      contractId: parseInt(this.$route.params.id, 10),
      UserTypes
    };
  },
  computed: {
    userType() {
      return this.$store.state.userType;
    },
    plans() {
      const plans = this.$store.state.Contracts.Plans.contractPlans;
      if (plans) {
        plans.sort((a, b) => a.name.localeCompare(b.name));
      }
      return plans;
    },
    isStoringContractPlan() {
      return this.$store.state.Contracts.Plans.isStoringContractPlan;
    }
  },
  created() {
    this.$store.dispatch("getContractPlans", this.contractId);
  },
  methods: {
    viewPlan(plan) {
      const win = window.open(plan.url);
      win.focus();
    },
    deletePlan(plan) {
      this.$store.dispatch("deletePlan", plan);
    },
    onFileChange(files) {
      if (files && files.length) {
        this.$store.dispatch("storeContractPlan", {
          contractId: this.contractId,
          plan: files[0]
        });
      }
    }
  }
};
</script>

<style scoped></style>
